import React, { Component } from 'react';
import { connect } from 'react-redux';
import { selectors as identitySelectors } from '../../reducers/identities';
import { selectors as configSelectors } from '../../reducers/configurations';
import SellerContractCreatePage from './createContract/ContractCreatePage';
import BuyerContractCreatePage from './createContract/buyerFlow/ContractCreatePage';
import Loading from '../Loading';
import BreadcrumbsEntry from '../common/breadcrumbs/BreadcrumbsEntry';
import BasicLayout from '../layouts/BasicLayout';
import { Button, Modal } from '@cimpress/react-components';
import RadioSelector, { RadioSelectorButton } from '@cimpress-technology/ff-react-components/lib/RadioSelector';
import { css } from 'emotion';
import ErrorRobot from '../common/ErrorRobot';
import { FFS_EMAIL_ADDRESS } from '../../constants/appConstants';
import { withTranslation } from 'react-i18next';

const center = css`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const BUYER_FLOW = 'MainCreatePage:BuyerFlow';
const SELLER_FLOW = 'MainCreatePage:SellerFlow';

class MainCreatePage extends Component {
  state = {
    selectedCreateFlow: undefined
  };

  setSelectedCreateFlow = option => {
    this.setState({ selectedCreateFlow: option });
  };

  onClose = () => {
    this.props.history.goBack();
  };

  render() {
    const { isFetchingUserConfigurations, hasFulfillerAccess, hasMerchantAccess, t } = this.props;
    const { selectedCreateFlow } = this.state;
    if (isFetchingUserConfigurations) {
      return <Loading />;
    }

    let flow;
    if (hasFulfillerAccess && hasMerchantAccess && !selectedCreateFlow) {
      flow = (
        <Modal
          show
          bsStyle="warning"
          title={t('createContract:chooseTypeModal.modalTitle')}
          footer={
            <Button type="default" onClick={this.onClose}>
              {t('common:commonWords.close')}
            </Button>
          }>
          <div className={center}>
            <RadioSelector onClick={this.setSelectedCreateFlow}>
              <RadioSelectorButton
                title={t('createContract:chooseTypeModal.buyerTypeTitle')}
                value={BUYER_FLOW}
                description={t('createContract:chooseTypeModal.buyerTypeDescription')}
              />
              <RadioSelectorButton
                title={t('createContract:chooseTypeModal.sellerTypeTitle')}
                value={SELLER_FLOW}
                description={t('createContract:chooseTypeModal.sellerTypeDescription')}
              />
            </RadioSelector>
          </div>
        </Modal>
      );
    } else if (selectedCreateFlow === SELLER_FLOW || (!selectedCreateFlow && hasFulfillerAccess)) {
      flow = <SellerContractCreatePage />;
    } else if (selectedCreateFlow === BUYER_FLOW || (!selectedCreateFlow && hasMerchantAccess)) {
      flow = <BuyerContractCreatePage />;
    } else {
      flow = (
        <ErrorRobot
          title={t('errors:error_create_permission')}
          msg={t('createContract:messages.requestPermissionsMessage', { email: FFS_EMAIL_ADDRESS })}
        />
      );
    }

    return (
      <BreadcrumbsEntry title={{ translationKey: 'breadcrumbs:createContracts' }}>
        <BasicLayout noStyle>{flow}</BasicLayout>
      </BreadcrumbsEntry>
    );
  }
}

const mapStateToProps = state => ({
  hasFulfillerAccess: identitySelectors.getHasFulfillerIdentities(state),
  hasMerchantAccess: identitySelectors.getHasMerchantIdentities(state),
  isFetchingUserConfigurations: configSelectors.getIsFetchingUserConfigurations(state)
});

export default connect(mapStateToProps)(withTranslation()(MainCreatePage));
